<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="my-html-cover"></a><img alt="image" src="image/cover.jpg" style="height:100%; text-align:center;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?46300846